import { dictionary } from './dictionary'
import { get } from 'lodash'

const keyToLabel = (
  key: string,
  scope: keyof typeof dictionary = 'base',
  overrides?: Record<string, string>
): string => {
  return (
    get(overrides, key) ||
    get(dictionary[scope], key) ||
    get(dictionary.base, key) ||
    key
  )
}

export { keyToLabel }
